var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.styles,on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon},on:{"click":function($event){}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }